

export function exists(val:any):boolean{
    if(val === undefined){
        return false;
    }
    if(val === null){
        return false;
    }
    return true;
}

export function has(obj:any, key:string){
    return obj.hasOwnProperty(key);
}


// WEBPACK FOOTER //
// ./src/ts/utils.ts